/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon, SaveAsIcon } from '@heroicons/react/outline'

export default function EditTestModal({ open, setOpen, test, updateTest }) {
    const [inputValue, setInputValue] = useState('');
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };
    const handleSave = () => {
        updateTest(test, inputValue)
        setInputValue('')
    }
    const handleClose = () => {
        setOpen()
        setInputValue('')
    }
    useEffect(() => {
        setInputValue(test.name);
    }, []);
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={handleClose}>
                <div className=" bg-opacity-0 bg-black flex justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="bg-white relative inline-block align-bottom rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl border border-gray-200 transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                            <div className="pb-5">
                                <h3 className="text-lg leading-6 font-bold text-black">Edit Test</h3>
                            </div>
                            <div>
                                <label htmlFor="testName" className="block text-sm font-medium text-black">
                                    Test Name
                                </label>
                                <div className="mt-1">
                                    <input
                                        type="text"
                                        name="testName"
                                        id="testName"
                                        value={inputValue}
                                        onChange={handleInputChange}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md bg-gray-50 text-black"
                                        placeholder=""
                                        aria-describedby=""
                                    />
                                </div>
                                <p className="mt-2 text-2xs text-gray-500" id="">
                                    Change your Test Name.
                                </p>

                                <button
                                    type="button"
                                    onClick={() => handleSave()}
                                    className="inline-flex float-end items-center px-3 py-2 mt-4 right-0 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-[#7035de] hover:bg-[#5a28b5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition">
                                    <SaveAsIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
                                    Save
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
